import { Extension } from '@tiptap/core';
/** Whether a suggestion popup (mentions, slash commands) is open; it owns Enter then. */
export function hasActiveSuggestion(state) {
    return state.plugins.some((plugin) => {
        const pluginState = plugin.getState(state);
        return (typeof pluginState === 'object' &&
            pluginState !== null &&
            'active' in pluginState &&
            pluginState.active === true);
    });
}
/**
 * Makes Enter submit the editor while Shift+Enter keeps breaking the line. Enter still selects
 * an item of an open suggestion popup.
 */
export function createSubmitOnEnterExtension(submit) {
    return Extension.create({
        name: 'submitOnEnter',
        // Ahead of the core Enter handling, which would split the block first.
        priority: 1000,
        addKeyboardShortcuts() {
            return {
                Enter: ({ editor }) => {
                    if (hasActiveSuggestion(editor.state)) {
                        return false;
                    }
                    submit();
                    return true;
                },
            };
        },
    });
}
